import { useDispatch, useSelector } from "react-redux";

import { RootState } from "store/store";
import { onSetModalApp } from "store/videoApp/videoAppSlice";

export const useVideoApp = () => {
    const dispatch = useDispatch();
    const {
        openModalApp
    } = useSelector((state: RootState) => state.videoApp);

    const setModalApp = (data: boolean) => dispatch(onSetModalApp(data));

    return {
        // props
        openModalApp,
        //methods
        setModalApp,
    }
};